// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { isCanada } from '../../../../../utils';
import Row from '../../../../common/atoms/Row';
import withStyles from '../../../../common/hoc/withStyles';
import styles from '../styles/AccountOverviewNew.style';
import AddressOverviewTile from '../../common/organism/AddressOverviewTile';
import PaymentOverviewTile from '../../common/organism/PaymentOverviewTile';
import MyPlaceRewardsCreditCardTile from '../../common/organism/MyPlaceRewardsCreditCard';
import ProfileInfoTile from '../../common/organism/ProfileInfoTile';
import MyPlaceRewardsOverviewTile from '../../common/organism/MyPlaceRewardsOverviewTile';
import MyWalletTile from '../../common/organism/MyWalletTile';
import EarnExtraPointsOverview from '../../common/organism/EarnExtraPointsOverview';
import OrdersTile from '../../common/organism/OrdersTile';
import MyPreferencesTile from '../../common/organism/MyPreferencesTile';
// import AccountDrawerBottomLinksNew from '../../AccountDrawer/molecules/AccountDrawerBottomLinksNew';

const componentMap = {
  profileInfoTile: ProfileInfoTile,
  addressOverviewTile: AddressOverviewTile,
  earnExtraPointsOverview: EarnExtraPointsOverview,
  paymentOverviewTile: PaymentOverviewTile,
  myPlaceRewardsOverviewTile: MyPlaceRewardsOverviewTile,
  myWalletTile: MyWalletTile,
  ordersTile: OrdersTile,
  myPreferencesTile: MyPreferencesTile,
  myPlaceRewardsCreditCardTile: MyPlaceRewardsCreditCardTile,
};

export const COMPONENTS_US = [
  'earnExtraPointsOverview',
  'ordersTile',
  'myWalletTile',
  'profileInfoTile',
  'paymentOverviewTile',
];

export const COMPONENTS_CA = [
  'ordersTile',
  'myWalletTile',
  'profileInfoTile',
  'paymentOverviewTile',
];

const AccountOverviewNew = ({ className, ...otherProps }) => {
  const componentList = isCanada() ? COMPONENTS_CA : COMPONENTS_US;
  const {
    globalLabels,
    commonLabels,
    accountLabels,
    componentBottonLink: ComponentBottonLink,
  } = otherProps;
  return (
    <Row fullBleed className={`${className} elem-pt-LRG account-dashboard-container`}>
      {componentList.map((componentName) => {
        const Component = componentMap[componentName];
        return (
          <Row key={componentName} fullBleed className={`${className} account-tile-item`}>
            <Component {...otherProps} />
          </Row>
        );
      })}
      <ComponentBottonLink
        showDashboardBottomLink={true}
        globalLabels={globalLabels}
        commonLabels={commonLabels}
        accountLabels={accountLabels}
      />
    </Row>
  );
};

AccountOverviewNew.propTypes = {
  className: PropTypes.string,
};

AccountOverviewNew.defaultProps = {
  className: '',
};
export default withStyles(AccountOverviewNew, styles);
